import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

class Grunnbokrapport extends Component {
    state = {
    }

    includeGrunndata = false
    includeHeftelser = false
    includeHjemmelsopplysninger = false
    includeServitutter = false
    includePengeheftelser = false
    includeFesteavtaler = false
    includeRettigheter = false

    onGrunndataChanged = event => {
        this.includeGrunndata = event.target.checked
    }

    onHeftelserChanged = event => {
        this.includeHeftelser = event.target.checked
    }

    onHjemmelsopplysningerChanged = event => {
        this.includeHjemmelsopplysninger = event.target.checked
    }

    onServitutterChanged = event => {
        this.includeServitutter = event.target.checked
    }

    onPengeheftelserChanged = event => {
        this.includePengeheftelser = event.target.checked
    }

    onFesteavtalerChanged = event => {
        this.includeFesteavtaler = event.target.checked
    }
    
    onRettigheterChanged = event => {
        this.includeRettigheter = event.target.checked
    }

    downloadGrunnbok = (event) => {
        event.stopPropagation()
        if (!this.includeGrunndata && !this.includeHeftelser && !this.includeHjemmelsopplysninger && !this.includeServitutter && !this.includePengeheftelser && !this.includeFesteavtaler && !this.includeRettigheter) return
        var url = `${this.props.settings.baseUrl}api/grunnbok/rapport?kommunenummer=${this.props.kommunenummer}&gardsnummer=${this.props.gardsnummer}&bruksnummer=${this.props.bruksnummer}&festenummer=${this.props.festenummer}&seksjonsnummer=${this.props.seksjonsnummer}&token=${this.props.token}&includeGrunndata=${this.includeGrunndata}&includeHeftelser=${this.includeHeftelser}&includeHjemmel=${this.includeHjemmelsopplysninger}&includeServitutter=${this.includeServitutter}&includePengeheftelser=${this.includePengeheftelser}&includeFesteavtaler=${this.includeFesteavtaler}&includeRettigheter=${this.includeRettigheter}`
        window.open(url, '_blank')
    }

    downloadGrunnbokHovedeiendom = (event) => {
        event.stopPropagation()

        var url = `${this.props.settings.baseUrl}api/grunnbok/rapport?kommunenummer=${this.props.kommunenummer}&gardsnummer=${this.props.gardsnummer}&bruksnummer=${this.props.bruksnummer}&token=${this.props.token}`
        window.open(url, '_blank')
    }

    downloadGrunnbokEiendom = (event) => {
        event.stopPropagation()

        var url = `${this.props.settings.baseUrl}api/grunnbok/rapport?kommunenummer=${this.props.kommunenummer}&gardsnummer=${this.props.gardsnummer}&bruksnummer=${this.props.bruksnummer}&festenummer=${this.props.festenummer}&seksjonsnummer=${this.props.seksjonsnummer}&token=${this.props.token}`
        window.open(url, '_blank')
    }

    render() {
        const { t } = this.props
        var documentKey = 0

        return (
            <li>
                <div className="section-header navigation" onClick={this.props.onNavigateBack}>
                    <span className="icon"><i className={"fa fa-fw fa-arrow-left"}></i></span>
                    <span className="title">{t('tilbake')}</span>
                </div>

                { (this.props.erFramfeste || this.props.seksjonsnummer > 0) &&
                    <div className="section-header subsection link" onClick={this.downloadGrunnbokHovedeiendom}>
                        <span className="title">{t('grunnboksrapporthovedeiendom')}</span>
                    </div>
                }
                { this.props.erFramfeste  && this.props.seksjonsnummer == 0 &&
                    <div className="section-header subsection link" onClick={this.downloadGrunnbokEiendom}>
                        <span className="title">{t('grunnboksrapportframfeste')}</span>
                    </div>
                }
                { this.props.seksjonsnummer > 0 &&
                    <div className="section-header subsection link" onClick={this.downloadGrunnbokEiendom}>
                        <span className="title">{t('grunnboksrapportseksjon')}</span>
                    </div>
                }
                <div className="section-header defaultcursor">
                    <span className="icon"><i className={"fa fa-fw fa-book"}></i></span>
                    <span className="title">{t('spesifisertgrunnboksrapport')}</span>
                </div>

                <div className="section-header defaultcursor description">
                    <span className="title">{t('velginnhold')}</span>
                </div>

                <ul>
                <li key={documentKey++} className="section-header defaultcursor">
                    <span className="checkbox"><input type="checkbox" onChange={this.onHjemmelsopplysningerChanged} /></span>
                    <span className="title">{t('hjemmelsopplysninger')}</span>
                </li>
                <li key={documentKey++} className="section-header defaultcursor">
                    <span className="checkbox"><input type="checkbox" onChange={this.onHeftelserChanged} /></span>
                    <span className="title">{t('heftelser')}</span>
                </li>
                <li key={documentKey++} className="section-header subheader defaultcursor">
                    <span className="checkbox"><input type="checkbox" onChange={this.onPengeheftelserChanged} /></span>
                    <span className="title">{t('pengeheftelser')}</span>
                </li>
                <li key={documentKey++} className="section-header subheader defaultcursor">
                    <span className="checkbox"><input type="checkbox" onChange={this.onServitutterChanged} /></span>
                    <span className="title">{t('servitutter')}</span>
                </li>
                <li key={documentKey++} className="section-header defaultcursor">
                    <span className="checkbox"><input type="checkbox" onChange={this.onRettigheterChanged} /></span>
                    <span className="title">{t('eiendommensrettigheter')}</span>
                </li>
                <li key={documentKey++} className="section-header defaultcursor">
                    <span className="checkbox"><input type="checkbox" onChange={this.onGrunndataChanged} /></span>
                    <span className="title">{t('grunndata')}</span>
                </li>
                </ul>

                <div className="section-header defaultcursor buttons">
                    <div className="button" onClick={this.downloadGrunnbok}>
                        {t('lastned')}
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Grunnbokrapport)